import { render, staticRenderFns } from "./RelatoriosCustomizados.vue?vue&type=template&id=edb722b6"
import script from "./RelatoriosCustomizados.vue?vue&type=script&lang=js"
export * from "./RelatoriosCustomizados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports